// import {
//   Box,
//   Button,
//   Stack,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Typography,
// } from "@mui/material";
// import React, { useState } from "react";
// import styles from "../../styles/pages/editors.module.scss";
// import assest from "../../json/assest";
// // import Image from 'next/image'
// import { Link } from "react-router-dom";
// import { useQuery } from "react-query";
// import { QCVIDEOMutation } from "../../api/functions/qc.api";
// import moment from "moment";
// import { concatHostAndImagePath } from "../../lib/functions/utils.lib";
// import Pagination from "../UtilitiesComponent/Pagination";
// import styles1 from "../../styles/pages/editors.module.scss";
// import QcConfirmFilter from "../AllFilterRow/SubmittedPageFilter/QcConfirmFilter";

// const QcModalTable = (props) => {
//   const [page, setPage] = useState(1);
//   const handleDataFromChild = (e) => {
//     setPage(e);
//     // Do something with the data received from the child component
//   };

//   const { data: VIDEOList, isLoading } = useQuery(
//     ["VIDEOList", props?.selectedId, page],

//     async () => {
//       return QCVIDEOMutation({
//         quality_team_id: props?.selectedId,
//         page: page,
//         manager_decision: 2,
//         quality_team_decision: 2,
//       });
//     }
//   );

import {
  Box,
  Button,
  InputAdornment,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import EmptyTable from "../../components/EmptyTable/EmptyTable";
import Filter from "../../components/Filter/Filter";
import React, { useEffect, useState } from "react";
import styles from "../../styles/pages/editors.module.scss";
import assest from "../../json/assest";
// import Image from 'next/image'
import { Link } from "react-router-dom";
import { useQuery } from "react-query";
import { QCVIDEOMutation } from "../../api/functions/qc.api";
import {
  concatHostAndImagePath,
  getUtcDate,
  getUtcDate1,
  getUtcTime,
  roleFinder,
} from "../../lib/functions/utils.lib";
import moment from "moment";
import CopywritersModalTable from "../CopywritersModalTable/CopywritersModalTable";
import Pagination from "../UtilitiesComponent/Pagination";
import ApiLoader from "../Loaders/ApiLoader";
import SubmittedPendingFilter from "../AllFilterRow/SubmittedPageFilter/SubmittedPendingFilter";
import SubmittedPendingFilterModal from "../FilterModal/SubmittedPendingFilterModal";

import FilterModal from "../FilterModal/FilterModal";
import QcwebsitewebsiteFilterModal from "../FilterModal/QcwebsitewebsiteFilterModal";
import QcConfirmFilter from "../AllFilterRow/SubmittedPageFilter/QcConfirmFilter";
import {
  setPage,
  setHasNote,
  setUnreachableSubmitter,
  setHasMessage,
  setMonth,
  setYear,
  setSubmitPlace,
  setUserId,
  setManagerId,
  setQualityTeamId,
  setPeopleAppearing,
  setPersonWhoFilmed,
  setSubmitOtherWebsite,
  setAgreementWithAnotherCompany,
  setFrom,
  setTo,
} from "../../redux-toolkit/slices/qc.confirm.approved.approved.slice";
import { useAppSelector } from "../../hooks/useAppSelector";
// import {
//   setAgreementWithAnotherCompany,
//   setDuplicates,
// } from "../../redux-toolkit/slices/qc.confirm.approved.approved.slice";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import QcrejectrejectFilterModal from "../FilterModal/QcrejectrejectFilterModal";
import QcWebsiteonlyRejectedFilterModal from "../FilterModal/QcWebsiteonlyRejectedFilterModal";
import NoResultTwo from "../NoResult/NoResultTwo";
import PaginationTwo from "../UtilitiesComponent/PaginationTwo";
import QcdenaiedwebsiteRejectdFilter from "../AllFilterRow/SubmittedPageFilter/QcdenaiedwebsiteRejectdFilter";

import magnifying from "../../../src/public/assets/images/icon-magnifying.svg";
import SearchOopsIcon from "../../public/assets/icons/SearchOopsIcon";
import QcdenaiedWebsiteonlyAprovvedFilter from "../AllFilterRow/SubmittedPageFilter/QcdenaiedWebsiteonlyAprovvedFilter";
import QcdenaiedRejectedWebsiteolyFilter from "../AllFilterRow/SubmittedPageFilter/QcdenaiedRejectedWebsiteolyFilter";
import QcConfirmApprovedApprovedFilter from "../AllFilterRow/SubmittedPageFilter/QcConfirmApprovedApprovedFilter";
import VideoPageFullModal from "../VideoPages/pages/VideoPageFullModal";
import WatchVideoModal from "../VideoPages/pages/WatchVideoModal";

const QcModalTable = (props) => {
  console.warn(
    "🚀 ~ file: QcModalTable.jsx:119 ~ QcModalTable ~ propsQcModalTable:",
    props?.name
  );
  const {
    // page,
    has_note,
    unreachable_submitter,
    hasMessage,
    month,
    year,
    submit_place,
    user_id,
    manager_id,
    quality_team_id,
    people_appearing,
    person_who_filmed,
    submit_other_website,
    aggrement_with_another_company,
    from,
    to,
    search,
  } = useAppSelector((s) => s.qcConfirmApproveApproveSlice);

  const dispatch = useAppDispatch();

  const {
    filterRowProps,
    datas,
    handlePageChange,

    p,
    // handleClearFilterModal,
    hideFilter,
  } = props;
  const [page, setPage] = useState(1);
  const handleDataFromChild = (e) => {
    setPage(e);
    // Do something with the data received from the child component
  };
  const [searchValue, setSearchValue] = React.useState("");
  const handleInputChange = (event) => {
    let inputValue = event.target.value;
    setSearchValue(inputValue);
    if (!inputValue) {
      filtersReset();
    }
  };

  const {
    data: VIDEOList,
    isLoading,

    refetch: refetchAgain,
  } = useQuery(
    ["VIDEOList", props?.selectedId, page, searchValue],

    async () => {
      return QCVIDEOMutation({
        quality_team_id: props?.selectedId,
        search: searchValue,
        page: page,
        manager_id,
        manager_decision: 1,
        quality_team_decision: 1,
        has_note,
        unreachable_submitter,
        submit_place: submit_other_website,
        country: submit_place,
        hasMessage,
        // month,
        // year,
        user_id,
        person_who_filmed,
        aggrement_with_another_company,
        // from,
        // to,
        from: month || year ? getStartEndDateTwo(month, year).start_date : from,
        to: month || year ? getStartEndDateTwo(month, year).end_date : to,
      });
    }
  );

  const [fetchTrigger, setFetchTrigger] = useState(Date.now());
  const handleTriggreFetch = () => {
    setFetchTrigger(Date.now());
  };
  const handlePageChange2 = (p) => {
    setPage(p);
    handleTriggreFetch();
  };
  const [openFilterModal, setOpenFilterModal] = useState(false);

  const filterRefetch = () => {
    refetchAgain();

    setOpenFilterModal(false);
  };

  const filtersReset = () => {
    // dispatch(setHasNote(null));
    // dispatch(setFrom(null));
    // dispatch(setTo(null));
    // dispatch(setSubmitPlace(null));
    // dispatch(setUserId(null));
    // dispatch(setMonth(null));
    // dispatch(setYear(null));
    // // dispatch(setDuplicates(null));searchValueny(null));
    // handleTriggreFetch();
    // setSearchValue("");
    // setOpenFilterModal(false);
    // dispatch(setManagerId(null));

    dispatch(setHasNote(null));
    dispatch(setSubmitPlace(null));
    dispatch(setUserId(null));
    dispatch(setMonth(null));
    dispatch(setYear(null));
    dispatch(setManagerId(null));
    setSearchValue("");
    dispatch(setHasMessage(null));
    // dispatch(setDuplicates(null));
    dispatch(setUnreachableSubmitter(null));
    dispatch(setPeopleAppearing(null));
    dispatch(setPersonWhoFilmed(null));
    dispatch(setSubmitOtherWebsite(null));
    dispatch(setAgreementWithAnotherCompany(null));
    setOpenFilterModal(false);
    handleTriggreFetch();
  };

  const handleClearFilterModal = () => {
    dispatch(setHasNote(null));
    dispatch(setSubmitPlace(null));
    dispatch(setUserId(null));
    dispatch(setMonth(null));
    dispatch(setYear(null));
    dispatch(setManagerId(null));
    dispatch(setHasMessage(null));

    // dispatch(setDuplicates(null));
    dispatch(setUnreachableSubmitter(null));
    dispatch(setPeopleAppearing(null));
    dispatch(setPersonWhoFilmed(null));
    dispatch(setSubmitOtherWebsite(null));
    dispatch(setAgreementWithAnotherCompany(null));
    setOpenFilterModal(false);
    handleTriggreFetch();
  };
  useEffect(() => {
    refetchAgain();
  }, [fetchTrigger]);

  const [filterActive, setFilterActive] = useState(false);

  useEffect(() => {
    if (
      // search ||
      has_note ||
      unreachable_submitter ||
      hasMessage ||
      month ||
      year ||
      submit_place ||
      user_id ||
      manager_id ||
      quality_team_id ||
      people_appearing ||
      person_who_filmed ||
      submit_other_website ||
      aggrement_with_another_company
    ) {
      setFilterActive(true);
    } else {
      setFilterActive(false);
    }
  }, [
    user_id,
    month,
    year,
    submit_place,
    // search,
    has_note,
    unreachable_submitter,
    people_appearing,
    person_who_filmed,
    submit_other_website,
    aggrement_with_another_company,
    quality_team_id,
    manager_id,
    hasMessage,
  ]);

  const [openModal, setOpenModal] = useState(false);
  const [id, setId] = useState();

  const onOpen = (id) => {
    setId(id);
    setOpenModal(true);
  };
  const onClose = () => {
    setId();
    setOpenModal(false);
    handleTriggreFetch();
  };

  const [openModalTwo, setOpenModalTwo] = useState(false);

  const onOpenTwo = (id) => {
    setId(id);
    setOpenModalTwo(true);
  };
  const onCloseTwo = () => {
    setId();
    setOpenModalTwo(false);
  };

  return (
    <>
      <QcConfirmApprovedApprovedFilter
        {...filterRowProps}
        filterActive={filterActive}
        VIDEOList={VIDEOList?.data}
        // FilterModalComponent={QcrejectrejectFilterModal}
        FilterModalComponent={QcWebsiteonlyRejectedFilterModal}
        filterModalProps={{
          searchValue,
          setSearchValue,
          openFilterModal,
          handleTriggreFetch,
          hideBottom: false,
          setOpenFilterModal,
          filterRefetch,
          filtersReset,
          handleClearFilterModal,
          handleInputChange,

          p,
          states: {
            // search,
            has_note,
            unreachable_submitter,
            hasMessage,
            month,
            year,
            submit_place,
            user_id,
            manager_id,
            quality_team_id,
            people_appearing,
            person_who_filmed,
            submit_other_website,
            aggrement_with_another_company,
            from,
            to,
          },
          setStates: {
            setHasNote,
            setUnreachableSubmitter,
            setHasMessage,
            setMonth,
            setYear,
            setSubmitPlace,
            setUserId,
            setManagerId,
            setQualityTeamId,
            setPeopleAppearing,
            setPersonWhoFilmed,
            setSubmitOtherWebsite,
            setAgreementWithAnotherCompany,
            setFrom,
            setTo,
          },
        }}
      />
      <Box className={`${styles.stickytable} ${styles.forQcdenied}`}>
        <Box className={`${styles.tableResponsive} ${styles.scrollRoot}`}>
          <TableContainer className={styles.tableperfectScroll}>
            <Table className={styles.qcMainTable} stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell className={styles.thQcvsid}>VSID</TableCell>
                  <TableCell className={styles.thQcAcquisitor}>
                    Acquisitor
                  </TableCell>
                  <TableCell className={styles.thQcThumbnail}>
                    Thumbnail
                  </TableCell>
                  <TableCell className={styles.thQcTitle}>Title</TableCell>
                  <TableCell className={styles.thQcSubmitterName}>
                    Submitter Name
                  </TableCell>

                  <TableCell className={styles.thQcEmail}>
                    Email Address
                  </TableCell>

                  <TableCell className={styles.thQcSubmissionDate}>
                    Submission Date
                  </TableCell>

                  <TableCell className={styles.thQcApprove}>
                    Approved by
                  </TableCell>

                  <TableCell className={styles.thQcConfirm}>
                    Confirmed on
                  </TableCell>

                  <TableCell align="center" className={styles.thQcView}>
                    View
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading ? (
                  <ApiLoader loading={isLoading} />
                ) : (
                  <>
                    {VIDEOList?.data?.data?.map((row) => (
                      <>
                        <TableRow
                          className={`${
                            row.type === "highlight"
                              ? `${styles.trHighlight}`
                              : null
                          }`}
                        >
                          <TableCell scope="row" className={styles.thQcvsid}>
                            <Typography variant="body2">
                              {row?.vsid}
                              {row.unseen_messages === true ? (
                                <span className={styles.redDot}></span>
                              ) : (
                                <></>
                              )}
                            </Typography>
                          </TableCell>

                          <TableCell className={styles.thQcAcquisitor}>
                            <Typography
                              variant="body2"
                              sx={{ textTransform: "capitalize" }}
                            >
                              {row.user?.name} {row.user?.last_name}
                            </Typography>
                            <Typography variant="overline">
                              {" "}
                              {roleFinder(row.user?.role_id)}
                            </Typography>
                          </TableCell>

                          <TableCell className={styles.thQcThumbnail}>
                            <img
                              onClick={() => onOpenTwo(row.id)}
                              src={concatHostAndImagePath(row?.thumbnail)}
                              width={73}
                              height={46}
                              alt="image"
                              className={styles.thumImg}
                            />
                          </TableCell>
                          <TableCell className={styles.thQcTitle}>
                            <Typography
                              variant="body1"
                              className={styles.tableTitle}
                            >
                              {row?.title}
                            </Typography>
                          </TableCell>
                          <TableCell className={styles.thQcSubmitterName}>
                            <Typography
                              variant="body2"
                              sx={{ textTransform: "capitalize" }}
                            >
                              {row?.first_name} {row?.last_name}
                            </Typography>
                          </TableCell>
                          <TableCell className={styles.thQcEmail}>
                            <Typography
                              variant="body2"
                              className={styles.emailTxt}
                            >
                              {row?.email}
                              <br />
                              {row?.did_anyone_reach === "true" ? (
                                <span className={styles.mailerror}>
                                  Unreachable Email
                                </span>
                              ) : null}
                            </Typography>
                          </TableCell>
                          <TableCell className={styles.thQcSubmissionDate}>
                            <Typography variant="body2">
                              {getUtcDate(row.created_at)} <br />
                              {getUtcTime(row.created_at)}
                            </Typography>
                          </TableCell>
                          <TableCell className={styles.thQcApprove}>
                            <Typography variant="body2">
                              {row?.manager.name} {row?.manager.last_name}
                            </Typography>
                            {row?.manager ? (
                              <Typography variant="caption">Manager</Typography>
                            ) : null}
                            <Typography
                              variant="body2"
                              className={styles.aprDate}
                            >
                              {row?.approveDate}

                              {getUtcDate1(row?.video_meta.manager_updated_at)}
                            </Typography>
                          </TableCell>
                          <TableCell className={styles.thQcConfirm}>
                            <Typography variant="body2">
                              {row?.video_meta.updated_at === null ? (
                                "Null"
                              ) : (
                                <>
                                  {getUtcDate(row?.video_meta.updated_at)}
                                  <br />
                                  {getUtcTime(row?.video_meta.updated_at)}
                                </>
                              )}
                            </Typography>
                          </TableCell>
                          <TableCell align="center" className={styles.thQcView}>
                            {/* <a
                                target="_blank"
                                href={`video/${row?.vsid}`}
                                className={styles.StyledeyeIcon}
                              > */}
                            <img
                              style={{ cursor: "pointer" }}
                              onClick={() => onOpen(row.vsid)}
                              src={assest.IconView}
                              width={16}
                              height={16}
                              alt="icon"
                            />
                            {/* </a> */}
                          </TableCell>
                        </TableRow>
                        <TableRow className={styles.blnkTd}>
                          <TableCell colSpan={10}></TableCell>
                        </TableRow>
                      </>
                    ))}
                    {VIDEOList?.data?.data?.length > 0 ? (
                      <TableRow className={styles.nonHover}>
                        <TableCell colSpan={10}>
                          {VIDEOList?.data.data.length <
                            VIDEOList?.data?.per_page &&
                          VIDEOList?.data.last_page == 1 ? (
                            <>
                              <p className={styles.endListMsg}>
                                End of list. We couldn't find more videos
                                matching your selected filter(s).
                              </p>
                            </>
                          ) : (
                            <>
                              <PaginationTwo
                                page={page}
                                count={VIDEOList?.data?.last_page}
                                handleChange={handlePageChange2}
                              />
                            </>
                          )}
                        </TableCell>
                      </TableRow>
                    ) : (
                      <TableRow className={styles.nonHover}>
                        <TableCell colSpan={10}>
                          {filterActive ? (
                            <Filter resetFilters={filtersReset} />
                          ) : (
                            <>
                              {searchValue === "" ? (
                                <NoResultTwo heading="pending" />
                              ) : (
                                <Box
                                  className={`${styles.dateRangeNoresult} ${styles.emptyResult}`}
                                >
                                  <Box className={styles.noFilter}>
                                    <figure>
                                      <SearchOopsIcon />
                                    </figure>
                                    <Typography variant="body1">
                                      We couldn’t find any matching approved
                                      videos for
                                      <span>{props?.name}</span>.
                                    </Typography>
                                  </Box>
                                </Box>
                              )}
                            </>
                          )}
                        </TableCell>
                      </TableRow>
                    )}
                  </>
                )}

                {/* search ||
                            has_note ||
                            unreachable_submitter ||
                            hasMessage ||
                            month ||
                            year ||
                            submit_place ||
                            user_id ||
                            manager_id ||
                            quality_team_id ||
                            people_appearing ||
                            person_who_filmed ||
                            submit_other_website ||
                            aggrement_with_another_company ||
                            !from ||
                            !to  */}

                <ApiLoader loading={isLoading} />
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        {/* {VIDEOList?.data?.total === 12 || VIDEOList?.data?.total < 12 ? (
            ""
          ) : (
            <Box className={styles.innerPagination}>
              <Pagination
                lastpage={VIDEOList?.data?.last_page}
                sendDataToParent={handleDataFromChild}
              />
            </Box>
          )} */}

        <WatchVideoModal
          onClose={onCloseTwo}
          open={openModalTwo}
          id={id}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="videoPageModal"
        />

        <VideoPageFullModal
          onClose={onClose}
          open={openModal}
          id={id}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="videoPageModal"
        />
      </Box>

      {/* ============================================= */}
      {/* ======== DATE RANGE NO RESULT START ========= */}

      {/* <Box className={styles.dateRangeNoresult}>
                <Box className={styles.noFilter}>
                    <figure>
                        <Image src={assest.iconOops} width={36} height={41} alt='icon' />
                    </figure>
                    <Typography variant='body1'>We couldn't find any approved videos within the specified date range.</Typography>
                </Box>
            </Box> */}

      {/* <Box className={styles.dateRangeNoresult}>
                <Box className={styles.noFilter}>
                    <figure>
                        <Image src={assest.smileIcon} width={36} height={42} alt='icon' />
                    </figure>
                    <Typography variant='body1'>We couldn't find any rejected videos within the specified date range.</Typography>
                </Box>
            </Box> */}

      {/* ============================================= */}
      {/* ========= DATE RANGE NO RESULT END ========== */}

      {/* ============================================= */}
      {/* ============= PAGE EMPTY START ============== */}

      {/* <Box className={`${styles.dateRangeNoresult} ${styles.emptyItem} ${styles.managerDaterange}`}>
                <Box className={styles.noFilter}>
                    <figure>
                        <Image src={assest.roundRing} width={207} height={210} alt='icon' />
                    </figure>
                    <Typography variant='body1'>You have no approved videos at the moment. Please reload the page or check back later.</Typography>
                </Box>
            </Box> */}

      {/* ============================================= */}
      {/* ============== PAGE EMPTY END =============== */}

      {/* ========================================== */}
      {/* ======= FOR FILTER NO RESULT START ======= */}

      {/* <Box className={`${styles.dateRangeNoresult} ${styles.emptyResult}`}>
                <Box className={styles.noFilter}>
                    <figure>
                        <Image src={assest.Magnifying} width={45} height={45} alt='icon' />
                    </figure>
                    <Typography variant='body1'>We couldn't find any matches for the selected filter(s).</Typography>
                    <Button>Reset filters</Button>
                </Box>
            </Box> */}

      {/* ========================================== */}
      {/* ======= FOR FILTER NO RESULT START ======= */}

      {/* ========================================== */}
      {/* ======= FOR SEARCH NO RESULT START ======= */}

      {/* <Box className={`${styles.dateRangeNoresult} ${styles.emptyResult}`}>
                <Box className={styles.noFilter}>
                    <figure>
                        <Image src={assest.Magnifying} width={45} height={45} alt='icon' />
                    </figure>
                    <Typography variant='body1'>We couldn’t find any matching approved videos for <span>john smith</span>.</Typography>
                </Box>
            </Box> */}

      {/* ========================================== */}
      {/* ======= FOR SEARCH NO RESULT START ======= */}
    </>
  );
};

export default QcModalTable;
